const features = [
  {
    icon: 'ri-4k-fill',
    title: '超清画质',
    desc: '主流剧集支持1080P高清播放，热门大作提供4K超清画质，智能码率自适应技术确保流畅不卡顿。',
  },
  {
    icon: 'ri-flashlight-fill',
    title: '极速更新',
    desc: '与播出平台实时同步，新剧上线最快30分钟即可观看，每日更新动态实时推送，追剧零延迟。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全端适配',
    desc: '桌面、平板、手机全端完美适配，跨设备无缝续看，随时随地享受高清追剧体验。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全纯净',
    desc: '无弹窗广告、无恶意跳转、无需注册登录，纯净观影环境守护你的每一次追剧时光。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 px-4 md:px-6 lg:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-950 mb-3">
            平台特色
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            为什么千万追剧达人选择午马影院？四大核心优势给你答案
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((item, index) => (
            <div
              key={index}
              className="group p-6 md:p-7 rounded-2xl border border-background-200 bg-background-50 hover:border-primary-300 hover:bg-primary-50/10 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-primary-100 flex items-center justify-center mb-4 md:mb-5 group-hover:bg-primary-500 transition-colors">
                <i className={`${item.icon} text-primary-500 text-xl md:text-2xl group-hover:text-background-50 transition-colors`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-950 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}